// Libs
import React, { Component } from 'react'
import Spinner from 'react-spinkit'

// Messages
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

// Constants
import { TITLE, MESSAGE } from '../constants'

// Styles
import { requestInfoStyle, titleStyle, messageStyle, spinnerStyle } from '../styles'
import { white } from 'fc-styles/src/colors'

type Props = {
  name: any,
  request: Object,
}

export default class Request extends Component {
  props: Props

  getRequestTitle () {
    return this.props.name + TITLE
  }

  getRequestMessage () {
    return this.props.name + MESSAGE
  }

  render () {
    const status = this.props.request.status

    return (
      <div style={requestInfoStyle(status)}>
        <div style={titleStyle}><FormattedMessage {...messages[this.getRequestTitle()]} /></div>
        <div style={messageStyle}><FormattedMessage {...messages[this.getRequestMessage()]} /></div>
        <div style={spinnerStyle}>
          <Spinner name='three-bounce' fadeIn='half' color={white()} />
        </div>
      </div>
    )
  }
}
